import React from 'react';
import FormPreview from '../formPreview';
import RiskEvolution from './riskEvolution';
import moment from 'moment';

export default function SubGroupView({
  canEdit,
  subGroupForm,
  linkingForms,
  subGroupFormData,
  linkingData,
  goToForm,
  subgroup,
  subsection,
  getRiskEvents,
  evolutionData,
  getEvolutionForm,
  hasRiskHistory,
  isRiskRelevant,
  location,
  participantOrgName,
}) {
  const form = getEvolutionForm();
  const events = getRiskEvents() || [];

  const { planning: { inputs = { measure: { options: [] }, status: { options: [] } } } } =
    form || {
      planning: {
        inputs: { measure: { options: [] }, status: { options: [] } }
      }
    };

  const getMappedEvents = (ids) => {
    return ids.map((id) => {
      const event = events.find((ev) => ev.id === id);
      return event;
    })
      .filter((e) => e);
  }

  const getRiskPlanData = (config) => {
    const plan = [];
    (config.planning || []).forEach(p => {
      const option = (inputs.measure && inputs.measure.options ? inputs.measure.options : []).find(o => o.value === p.measure);
      plan.push({
        objective: 'reduceVulnerability',
        type: option ? option.label : '',
        title: p.title,
        stakeholderId: p.stakeholderId,
        responsible: p.stakeholderId &&
          linkingData.Stakeholder &&
          linkingData.Stakeholder[p.stakeholderId] ?
          linkingData.Stakeholder[p.stakeholderId].name : '',
        status: p.status,
        events: getMappedEvents(p.events || []),
        completedAt: p.completedAt,
        stakeholder: p.stakeholderId &&
          linkingData.Stakeholder &&
          linkingData.Stakeholder[p.stakeholderId] ?
          linkingData.Stakeholder[p.stakeholderId] : null,
        statusOptions: inputs.status ? inputs.status.options : [],
        createdAt: p.createdAt,
        details: p.details,
        proposedDate: p.proposedDate,
      });
    });
    (config.otherPlanning || []).forEach(p => {
      const option = (inputs.measure && inputs.measure.options ? inputs.measure.options : []).find(o => o.value === p.measure);
      plan.push({
        objective: 'generalImprovement',
        type: option ? option.label : '',
        title: p.title,
        events: getMappedEvents(p.events || []),
        completedAt: p.completedAt,
        responsible: p.stakeholderId &&
          linkingData.Stakeholder &&
          linkingData.Stakeholder[p.stakeholderId] ?
          linkingData.Stakeholder[p.stakeholderId].name : '',
        stakeholder: p.stakeholderId &&
          linkingData.Stakeholder &&
          linkingData.Stakeholder[p.stakeholderId] ?
          linkingData.Stakeholder[p.stakeholderId] : null,
        status: p.status,
        statusOptions: inputs.status ? inputs.status.options : [],
        createdAt: p.createdAt,
        details: p.details,
        proposedDate: p.proposedDate,
      });
    });

    return plan.sort((a, b) => moment(b.createdAt).isBefore(moment(a.createdAt)));;
  }


  return (
    <>
      <FormPreview
        canEdit={false}
        form={subGroupForm}
        linkingForms={linkingForms}
        data={subGroupFormData}
        linkingData={linkingData}
        onEdit={() => goToForm('identification')}
      />
      <RiskEvolution
        subGroup={subgroup}
        subSection={subsection}
        canEdit={canEdit}
        events={events}
        data={evolutionData.config}
        getRiskPlanData={getRiskPlanData}
        updatedAt={evolutionData.updatedAt}
        form={form}
        hasRisk={hasRiskHistory()}
        linkingData={linkingData}
        managementDisabbled={!isRiskRelevant(['yes', 'no', 'unsure'])}
        onPlan={() => goToForm('planning')}
        onManage={() => goToForm('management')}
        location={location}
        score={evolutionData.score}
        category={evolutionData.category}
        subCategory={evolutionData.subCategory}
        organisationName={participantOrgName}
      />
    </>
  );
}
